// extracted by mini-css-extract-plugin
export default {"dates":"search__dates___[chunkhash-base64-5]"};